import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Segment, Table, Input } from 'semantic-ui-react';
import { updatePayments } from './utils';

class ProfilePayments extends Component {
  static propTypes = {
    influencer: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      editing: false,
      paypalEmail: props.influencer.paypalEmail,
      discountCode: props.influencer.discountCode,
    };
  }

  handleChange = (e, v) => this.setState({ [v.name]: v.value });

  reset = () => this.setState({
    editing: false,
    paypalEmail: this.props.influencer.paypalEmail,
    discountCode: this.props.influencer.discountCode,
  });

  handleUpdatePayments = () => {
    const influencerID = this.props.influencer.id;
    const {
      paypalEmail,
      discountCode,
    } = this.state;
    updatePayments(influencerID, paypalEmail, discountCode);
    this.setState({ editing: false });
  }

  render() {
    const {
      editing,
      paypalEmail,
      discountCode,
    } = this.state;

    return (
      <Segment padded>
        <h3>Payments & Discount Codes</h3>
        <Table basic="very">
          <Table.Body>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Paypal Email</p>
              </Table.Cell>
              <Table.Cell>
                <Input name="paypalEmail" value={paypalEmail} onChange={this.handleChange} fluid readOnly={!editing} />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Shopify Discount Code</p>
              </Table.Cell>
              <Table.Cell>
                <Input name="discountCode" value={discountCode} onChange={this.handleChange} fluid readOnly={!editing} />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        { editing ?
          <div className="flex">
            <div className="space">
              <div className="spacer small" />
              <Button size="medium" basic fluid onClick={this.reset}>Cancel</Button>
            </div>
            <div className="space">
              <div className="spacer small" />
              <Button size="medium" color="pink" fluid onClick={this.handleUpdatePayments}>Save Changes</Button>
            </div>
          </div>
          :
          <div className="flex">
            <div className="space">
              <div className="spacer small" />
              <Button size="medium" basic fluid onClick={() => this.setState({ editing: true })}>Edit Payments & Discount Codes</Button>
            </div>
          </div>
        }
      </Segment>
    );
  }
}

export default ProfilePayments;



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/profile-payments.js
 **/